import { all, call, take, spawn, put } from 'redux-saga/effects';

import { getLogger } from '../../logger/index';
import { INIT_PLUGIN_COMMS_CENTER } from '../communication/actions';

import sagaSocketEvents from './sagaSocketEvents';
import sagaOutgoingCall from './sagaOutgoingCall';
import sagaIncommingCall from './sagaIncommingCall';
import sagaEndCall from './sagaEndCall';
import sagaCallChange from './sagaCallChange';
import { watchCustomerActions } from './sagaCustomer';
import { initialized } from './actions';

const logger = getLogger('communicationVideo');

function* fireupPlugin(plugin) {
  logger.debug(`Plugin "${plugin.name}" is initializing`);
  yield all(
    [
      sagaSocketEvents,
      sagaOutgoingCall,
      sagaIncommingCall,
      sagaEndCall,
      sagaCallChange,
      watchCustomerActions,
    ].map(watcher => spawn(watcher))
  );
  logger.debug(`Plugin "${plugin.name}" is initialized`);
  logger.debug('CommunicationVideo initialized');
  yield put(initialized());
}

function* watchPluginInit() {
  const { payload: plugin } = yield take(INIT_PLUGIN_COMMS_CENTER);
  yield call(fireupPlugin, plugin);
}

export default [watchPluginInit];
